import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';

/**
 * Default pagination constants for position queries.
 *
 * These constants are shared across all position-related query creators
 * to ensure consistent pagination behavior.
 */
export const DEFAULT_POSITIONS_PAGE = 1;
export const DEFAULT_POSITIONS_LIMIT = 100;

/**
 * Configuration key for query settings used across all account-related queries.
 */
export const CONFIG_KEY = QueryConfigKeys.ACCOUNT;

/**
 * Account-specific query keys for consistent cache management.
 */
export const ACCOUNT_QUERY_KEYS = QUERY_KEYS[CONFIG_KEY];

/**
 * Account-specific query configurations for consistent cache management.
 */
export const ACCOUNT_QUERY_CONFIGS = QUERY_CONFIGS[CONFIG_KEY];

/**
 * Account-specific stale time for consistent cache management.
 */
export const ACCOUNT_STALE_TIME = QUERY_CONFIGS[CONFIG_KEY].staleTime;

/**
 * Configuration key for program-related queries.
 */
export const PROGRAM_CONFIG_KEY = QueryConfigKeys.PROGRAMS;

/**
 * Program-specific query keys for consistent cache management.
 */
export const PROGRAM_QUERY_KEYS = QUERY_KEYS[PROGRAM_CONFIG_KEY];

/**
 * Program-specific query configurations for consistent cache management.
 */
export const PROGRAM_QUERY_CONFIGS = QUERY_CONFIGS[PROGRAM_CONFIG_KEY];

/**
 * Program-specific stale time for consistent cache management.
 */
export const PROGRAM_STALE_TIME = QUERY_CONFIGS[PROGRAM_CONFIG_KEY].staleTime;

/**
 * Polling interval for trades table data.
 * Aligned with backend position sync job frequency (30 seconds).
 */
export const TRADES_POLLING_INTERVAL = 30000; // 30 seconds in milliseconds

/**
 * Custom stale time for trades data to ensure real-time updates.
 * Set slightly less than polling interval to ensure fresh data on each poll.
 */
export const TRADES_STALE_TIME = 25000; // 25 seconds in milliseconds
